// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"38f75b4f","787":"76201726"}[chunkId] + ".chunk.js";
};